import React from 'react';
import makeBodyText from '../../../utils/makeText';
import makeIconName from '../../../utils/makeIconName';
import styles from './index.module.scss';
const Item = ({ text, icon }) => {
    return (React.createElement("li", { className: styles.wrapper },
        React.createElement("i", { className: makeIconName(icon || 'checked', 'x24') }),
        React.createElement("span", { className: makeBodyText('XL') }, text)));
};
export default Item;
